import * as React from 'react';
export const CarouselContext = React.createContext(null);
/** Carousel 하위 부품이 Embla API·스크롤 상태를 읽는다. */
export function useCarousel() {
    const context = React.useContext(CarouselContext);
    if (!context) {
        throw new Error('useCarousel must be used within a <Carousel />');
    }
    return context;
}
//# sourceMappingURL=carousel-context.js.map